import React, { useEffect, useState } from 'react'
import SubTitle from '../Components/SubTitle'
import "react-day-picker/style.css";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchWithToken } from '../redux/hooks/useFetchWithToken';
import Loading from './Loading';

const Orders = () => {

  const titles=[{name:'طلباتى',link:''}]
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const {data,isLoading,error}=useFetchWithToken('api/order/get_orders')
  console.log(data);
  useEffect(()=>{
    if(data){
      console.log('====================================');
      console.log(data.data);
      console.log('====================================');
      setOrders(data.data)
    }
  },[data])
  return (
    <div>
        <div className='container mt-lg-5 py-5 mb-2'>
        <SubTitle titles={titles}/>  

        <div className=''>
           <div className='row'>
           
               <div className='col-lg-3 p-4'>
                  <div className='position-relative '>
                  <div className='right-profile d-none d-lg-flex flex-column gap-1'>
               
                    <div className='right-profile-list'>
                       <Link to="/">
                       <i class="fa-regular fa-circle-user"></i>
                       حسابى
                       </Link>
                       <Link to="/">
                       <i class="fa-solid fa-box"></i>
                       الطلبات
                       </Link>
                       <Link to="/">
                       <i class="fa-solid fa-arrow-right-from-bracket"></i>
                       تسجيل الخروج
                       </Link>
                    </div>
          </div>
                  </div>
               </div>
               <div className='col-lg-9'>
                {isLoading?(
                  <Loading/>
                ):(
                  <div className='flex flex-col '>
                     <h4>الطلبات</h4>
                    <div>
                        {orders.length>0?(

                        <table className="table table-borderless table-hover mt-5 mb-5">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">رقم الطلب</th>
                            <th scope="col">حالة الطلب</th>
                            <th scope="col">تاريخ الطلب</th>
                            <th scope="col">طريقة الدفع</th>
                            <th scope="col">السعر الإجمالي</th>
                            {/* <th scope="col">عرض الطلب</th> */}
                          </tr>
                        </thead>
                        <tbody>
                           {orders.map((order,index)=>(
                             <tr key={order.id}>
                             <th scope="row">{index+1}</th>
                             <td>{order.order_number}</td>
                             <td>{order.status}</td>
                             <td>{new Date(order.created_at).toLocaleDateString("en-GB")}</td>
                             <td>الدفع عند الإستلام</td>
                             <td>{order.billing_total} جنيه</td>
                             {/* <td>
                               <button  className="btn btn-dark">
                                 عرض الطلب
                               </button>
                               
                             </td> */}
                           </tr>
                           ))}
                        </tbody>
                      </table>
                  
                        ):(
                            <div className='d-flex  justify-content-center align-items-center'>
                            <div className='cart-image'>
                           <i className="fa fa-cart-shopping bar cart"style={{ borderRadius:'40px',width:'60px',height:'60px' }}>
                           </i>
                           </div>
                          <p style={{ fontSize:'18px',display:'inline-block' }}>لا يوجد طلبات</p>
                       </div>
                        )}
                    </div>
                  </div>
                )} 
                 
               </div>
           </div>
         
        </div>
        </div>   
    </div>
  )
}

export default Orders